export enum CorporateLocationType {
  SALES = 'sales',
  SHIPPING = 'shipping',
}
